<mat-toolbar class="mainNavbar">
  <div class="mainNavbar_item mainNavbar_item--logoWrapper" data-cy="navbar-logo-link" [routerLink]="['/']">
    <svg class="mainNavbar-logoImg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 447 93">
      <g>
        <path fill="#1D1D1B" d="M340.5,0h4.3v93.4h-4.3V0z" />
        <path fill="#1D1D1B" d="M0,17.3h8v51.1h19.2v8H0V17.3z" />
        <!-- prettier ignore -->
        <path
          fill="#1D1D1B"
          d="M102.6,17.4h8.1v36.3c0,5.4,1.3,9.5,3.9,12.5c2.6,2.9,6.2,4.4,11,4.4c4.7,0,8.3-1.3,11-4c2.7-2.7,4-6.5,3.9-11.4V17.4h8.1 v37.2c0,7.2-2.1,13-6.2,17.3c-4.1,4.3-9.6,6.5-16.5,6.5c-7,0-12.6-2.2-16.9-6.6s-6.3-10.9-6.3-19.4L102.6,17.4z" />
        <path fill="#1D1D1B" d="M161.9,17.3H198v8.1h-14.1v51h-8v-51h-14V17.3z" />
        <path fill="#1D1D1B" d="M211.8,17.3h32.8v8.1h-24.8v14.8h24.8v8h-24.8v20.3h24.8v8h-32.8V17.3z" />
        <!-- prettier ignore -->
        <path
          fill="#1D1D1B"
          d="M307,19.4v9.1c-6.4-3.1-12.2-4.7-17.6-4.7c-6.4-0.2-12.7,2.2-17.4,6.6c-4.6,4.2-7.2,10.1-7.1,16.3 c-0.1,6.3,2.5,12.3,7.2,16.5c4.8,4.4,10.8,6.6,18.1,6.6c5.3,0,10.8-1.7,16.7-5V74c-5.4,2.8-11.3,4.3-17.4,4.3 c-8.8,0.2-17.2-3.2-23.5-9.3c-6.3-5.7-9.8-13.9-9.7-22.4c-0.1-8.4,3.4-16.4,9.6-22c6.2-6,14.5-9.3,23.1-9.2 C295.3,15.5,301.3,16.9,307,19.4z" />
        <!-- prettier ignore -->
        <polygon
          fill="#1D1D1B"
          points="65.9,15 61.7,24.3 65.9,33.5 65.9,33.5 75.4,54.6 48.1,54.6 45.1,61.3 53.4,61.3 78.5,61.3 85.3,76.4 93.8,76.4 " />
        <!-- prettier ignore -->
        <path
          fill="#1D1D1B"
          d="M446.3,66l-7.4-4.3c4.6-7.7,5.6-17.1,2.8-25.7c-2.5-8-7.7-14-15.6-17.9c-7.6-3.9-16.5-4.5-24.6-1.9 c-8.3,2.4-15.3,8-19.4,15.6c-4.3,7.2-5.2,15.9-2.7,23.8c2.4,8.2,8.1,15,15.7,18.8c7.7,4,16.6,4.8,24.8,2.1c2.5-0.8,4.8-1.9,7.1-3.2 l-8.8-5.1l-0.4,0.2c-6.1,2-12.8,1.6-18.5-1.3c-5.6-2.6-9.9-7.6-11.6-13.6c-1.9-5.9-1.3-12.3,1.8-17.7c2.9-5.6,8-9.7,14.1-11.4 c6.1-2.1,12.8-1.6,18.6,1.2c5.6,2.7,9.8,7.7,11.5,13.6c2,6.2,1.2,12.9-2.1,18.5l-7.7-4.4l-3.8,6.6l22.3,13L446.3,66z" />
      </g>
    </svg>
  </div>

  @if (displayProjectPicker()) {
    <div class="mainNavbar_item mainNavbar_item--projectPickerWrapper">
      <app-project-picker
        [projects]="projects()"
        [selectedProjectId]="selectedProjectId()"
        [disabled]="pickersDisabled()"
        (selected)="selectProject($event)" />
    </div>
  }

  <div class="mainNavbar_item mainNavbar_item--rightSide">
    <app-notifications-bell />

    @if (selectedAccount(); as selectedAccount) {
      <div class="userManual">
        <button mat-button title="User manual" data-cy="navbar-user-manual-button" (click)="downloadUserManual()">
          <mat-icon svgIcon="lifebuoy" class="icon--large" />
        </button>
      </div>

      <div class="modulePicker" [matMenuTriggerFor]="modulesMenu">
        <button mat-button title="Module picker" data-cy="navbar-module-picker-menu-button">
          <mat-icon svgIcon="apps" class="icon--large" />
        </button>

        <mat-menu #modulesMenu="matMenu" class="m-2" xPosition="before">
          <ng-template matMenuContent>
            @if (modules()?.length) {
              <div class="modules">
                <!-- Modules with access -->
                @for (module of modulesWithAccess(); track $index) {
                  <div
                    class="modules_item"
                    mat-menu-item
                    [attr.data-cy]="`navbar-module-${module.id}-menu-item`"
                    (click)="navigateToModule(module)">
                    <div class="moduleDetails">
                      <img alt="Module icon" [src]="module.favIconUrl" />

                      <div>
                        <span>{{ module.name }}</span>
                        <div class="text-muted">
                          <span>{{ module.description }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="activeModule">
                      <mat-icon svgIcon="check" />
                      <span>Active</span>
                    </div>
                  </div>
                }

                <!-- Core module -->
                <div
                  class="modules_item"
                  mat-menu-item
                  data-cy="navbar-core-module-menu-item"
                  (click)="navigateToModule(CoreModule)">
                  <div class="moduleDetails">
                    <img alt="Core module fav icon" [src]="CoreModule.favIconUrl" />

                    <div>
                      <span>{{ CoreModule.name }}</span>

                      <div class="text-muted">
                        <span>{{ CoreModule.description }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="activeModule">
                    <mat-icon svgIcon="check" />
                    <span>Active</span>
                  </div>
                </div>

                <!-- Modules without access -->
                @for (module of modulesWithoutAccess(); track $index) {
                  <div
                    class="modules_item"
                    mat-menu-item
                    [attr.data-cy]="`navbar-module-${module.id}-menu-item`"
                    (click)="navigateToModule(module)">
                    <div class="moduleDetails">
                      <img alt="Module fav icon" [src]="module.favIconUrl" />

                      <div>
                        <span>{{ module.name }}</span>

                        <div class="text-muted">
                          <span>{{ module.description }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="noAccessModule">
                      <span>Find out more</span>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="text-muted p-3">
                <i>No apps available</i>
              </div>
            }
          </ng-template>
        </mat-menu>
      </div>

      <div class="userProfile">
        <button
          mat-button
          class="text-initial"
          data-cy="navbar-user-profile-menu-button"
          [matMenuTriggerFor]="menu"
          (click)="onUserProfileMenuTriggered()">
          <app-account-signature [account]="selectedAccount" [onlyAvatar]="true" [displayTooltip]="false" />

          <div class="d-flex align-items-center">
            <div class="userProfile_info d-flex flex-column text-start ms-2">
              <span class="text-start text-truncate">
                {{ selectedAccount?.firstName }} {{ selectedAccount?.lastName }}
              </span>

              @let variables =
                {
                  clients: clients(),
                  selectedClientId: selectedClientId()
                };

              <span class="text-small text-muted text-truncate">
                {{
                  selectedAccount?.client?.name ??
                    (variables.clients | findByProperty: 'id' : variables.selectedClientId)?.name
                }}
              </span>
            </div>

            <mat-icon class="iconRight" svgIcon="menu-down" />
          </div>
        </button>

        <mat-menu #menu="matMenu" xPosition="before" class="m-2 defaultWidth">
          <div class="userProfile_accountSection">
            <app-account-signature [account]="selectedAccount" [onlyAvatar]="true" [displayTooltip]="false" />

            <div>{{ selectedAccount?.firstName }} {{ selectedAccount?.lastName }}</div>

            <div class="text-small text-muted">{{ user()?.email }}</div>

            <a data-cy="navbar-my-account-link" (click)="navigateToMyAccount(selectedAccount)">
              <span>My Account</span>
            </a>
          </div>

          @if (displayAccountPicker()) {
            <div class="accountPicker">
              <app-account-picker
                [accounts]="user()?.accounts"
                [selectedAccountId]="selectedAccount.id"
                [disabled]="pickersDisabled()"
                (selected)="selectAccount($event)" />
            </div>
          }
          @if (displayClientPicker()) {
            <div class="clientPicker">
              <app-client-picker
                [clients]="clients()"
                [selectedClientId]="selectedClientId()"
                [disabled]="pickersDisabled()"
                (selected)="selectClient($event)" />
            </div>
          }

          <button mat-menu-item class="userProfile_signOutBtn" data-cy="navbar-sign-out-menu-item" (click)="signOut()">
            <mat-icon svgIcon="logout" />
            <span>Sign out</span>
          </button>
        </mat-menu>
      </div>
    } @else {
      <button
        mat-button
        class="my-auto me-4 userProfile_signOutBtn"
        data-cy="navbar-sign-out-button"
        (click)="signOut()">
        <mat-icon svgIcon="logout" />
        <span>Sign out</span>
      </button>
    }
  </div>
</mat-toolbar>
